import { ButtonBase, Typography } from '@material-ui/core'
import DownArrowIcon from '@material-ui/icons/ArrowDropDown'

import { getTranslate } from '../../localization'
import useStyles from './styles/InventorySecondaryFiltersTrigger'

interface InventorySecondaryFiltersTriggerProps {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
}

const InventorySecondaryFiltersTrigger: React.FC<
  InventorySecondaryFiltersTriggerProps
> = ({ isOpen, setIsOpen }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <ButtonBase className={classes.header} onClick={() => setIsOpen(!isOpen)}>
        <Typography>
          {getTranslate(isOpen ? 'Hide Filters' : 'Show Filters')}
        </Typography>
        <DownArrowIcon
          className={[
            classes.downArrowIconRight,
            isOpen ? classes.downArrowIconCollapsed : ''
          ].join(' ')}
        />
      </ButtonBase>
    </div>
  )
}

export default InventorySecondaryFiltersTrigger
